<template>
<div>
  <span class="d-inline-flex" style="width: 200px;">
    <b class="mr-2">{{ title }}</b>
  </span>
  <v-range-slider
    :max="max"
    :min="min"
    hide-details
    class="align-center"
    tick-size="4"
    :step="step"
    :tick-labels="tickLabels"
    @change="onChange"
    :value="data"
  >
  </v-range-slider>
</div>
</template>

<script>
export default {
  data () {
    return {
      data: []
    }
  },
  methods: {
    onChange (value) {
      this.$emit('input', value)
    }
  },
  computed: {
    // v-range-slider places tick labels one per STEP, so the array has to be as long as there are
    // steps in the range or every label after the first lands on the wrong tick. Only the whole
    // months are named; the steps in between get a tick with no label under it.
    tickLabels () {
      const labels = []
      for (let value = this.min; value <= this.max + this.step / 2; value += this.step) {
        const rounded = Math.round(value * 100) / 100
        labels.push(Number.isInteger(rounded) ? rounded.toString() : '')
      }
      return labels
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value && this.value !== this.data) {
          this.data = this.value
        }
      }
    },
    min: {
      immediate: false,
      handler () {
        if (this.min > this.data[0]) {
          this.$set(this.data, 0, this.min)
        }
      }
    },
    max: {
      immediate: false,
      handler () {
        if (this.max < this.data[1]) {
          this.$set(this.data, 1, this.max)
        }
      }
    }
  },
  props: {
    value: {
      type: Array
    },
    max: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    // Whole months unless a caller asks for finer. A wizard that derives a half-life from a model
    // report passes a quarter of a month so what it derived is not rounded away before it is
    // sent; the old wizard, which has no derived value to preserve, leaves it alone.
    step: {
      type: Number,
      default: 1
    }
  }
}
</script>
